import { WidgetButton } from "@fidget/common/components/widgetButton/widgetButton";
import React, { useState } from "react";
import { L10n } from "../../i18n";
import { intl } from "../../i18n/TypedIntl";
import { CollapsibleContainer } from "../collapsibleContainer";
import { WidgetCheckboxInput } from "../inputs/widgetCheckboxInput/widgetCheckboxInput";
import styles from "./chatContactEnquiry.css";
import { BackgroundType, ChatItemBorder } from "./chatItemBorder";
import { ContactInput } from "./contactInput";
import { PhoneHandlerGoogle } from "../../services/PhoneHandlerGoogle";

interface Props {
  message: string;
  showConsent?: boolean;
  onSubmit?: (contact: string) => void;
  messageId: string;
  phoneRegion?: string;
}

export const ChatContactEnquiry = ({
  message,
  messageId,
  showConsent = false,
  onSubmit,
  phoneRegion
}: Props) => {
  const [contact, setContact] = useState<string>("");
  const [checked, setChecked] = useState<boolean>(false);

  const submit = async () => {
    if (onSubmit) {
      const phoneHandler = await PhoneHandlerGoogle.getInstance();
      const parsedNumber = phoneHandler.parse(contact, phoneRegion);
      const contactWithPrefix = parsedNumber?.isValid() ? parsedNumber.number : contact;
      onSubmit(contactWithPrefix);
    }
    setContact("");
  };

  const render = () => {
    return (
      <ChatItemBorder backgroundType={BackgroundType.AGENT} widgetStyle>
        {onSubmit && (
          <>
            <ContactInput onChange={setContact} phoneRegion={phoneRegion} />
            <div className={styles.gdpr}>
              {showConsent && (
                <>
                  <CollapsibleContainer isTextCollapsed text={message} />
                  <WidgetCheckboxInput
                    id={messageId + "gdpr-agreement"}
                    colorSchema="primary"
                    className={styles["checkbox-margin"]}
                    label={intl.formatMessage("widget.chat.gdpr.agreementTitle")}
                    checked={checked}
                    onChange={setChecked}
                  />
                </>
              )}
              <WidgetButton
                disabled={(showConsent ? !checked : false) || !contact}
                onClick={submit}
                fullWidth
                buttonStyle={"primary"}
              >
                <L10n id={"widget.chat.gdpr.save"} />
              </WidgetButton>
            </div>
          </>
        )}
      </ChatItemBorder>
    );
  };

  return render();
};

// tslint:disable-next-line:no-default-export
export default ChatContactEnquiry;
